// Contact.js - Updated loading state
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ResidentSidebar from '../components/ResidentSidebar';
import EditablePage from '../components/EditablePage';
import { getPageContent, savePageContent } from '../components/pageContentService';
import '../css/Basispagina.css';
import '../css/Contact.css';

const Contact = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'nl');
  const [pageContent, setPageContent] = useState({
    title: 'Contact Informatie',
    titleEn: 'Contact Information',
    
    // Board section
    boardTitle: 'VVE Bestuur',
    boardTitleEn: 'HOA Board',
    boardHtml: `
      <p>Voor vragen over het gebouw, gemeenschappelijke voorzieningen en VVE-zaken.</p>
      <p><strong>E-mail:</strong> <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
      <p>U kunt een bericht sturen naar het bestuur voor algemene vragen, suggesties of opmerkingen.</p>
    `,
    boardHtmlEn: `
      <p>For questions about the building, common facilities and HOA matters.</p>
      <p><strong>E-mail:</strong> <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
      <p>You can send a message to the board for general questions, suggestions or comments.</p>
    `,
    
    // Manager section
    managerTitle: 'VVE Beheerder',
    managerTitleEn: 'HOA Manager',
    managerHtml: `
      <p>Van Roemburg VVE Beheer regelt de servicekosten en stookkosten.</p>
      <p><strong>E-mail:</strong> <a href="mailto:beheer@vanroemburg.info">beheer@vanroemburg.info</a></p>
      <p><strong>Telefoon:</strong> 085-7600225</p>
      <p>Bereikbaar op werkdagen tussen 9:00 en 17:00 uur.</p>
    `,
    managerHtmlEn: `
      <p>Van Roemburg VVE Beheer handles the service costs and heating costs.</p>
      <p><strong>E-mail:</strong> <a href="mailto:beheer@vanroemburg.info">beheer@vanroemburg.info</a></p>
      <p><strong>Phone:</strong> 085-7600225</p>
      <p>Available on weekdays between 9:00 and 17:00.</p>
    `,
    
    // Maintenance section
    maintenanceTitle: 'Storingen en Onderhoud',
    maintenanceTitleEn: 'Malfunctions and Maintenance',
    maintenanceHtml: `
      <p>Voor urgente storingen en onderhoudskwesties.</p>
      <p>Bij storingen aan lift, centrale verwarming of andere dringende zaken:</p>
      <ul>
        <li><strong>Liftstoring:</strong> Bel direct het nummer op de lift</li>
        <li><strong>CV-storing (Toren):</strong> Contact opnemen met beheerder</li>
        <li><strong>Waterschade/Lekkage:</strong> In noodgevallen: 06-XXXXXXXX</li>
      </ul>
      <p class="note">Bij acuut gevaar of calamiteiten, bel altijd 112.</p>
    `,
    maintenanceHtmlEn: `
      <p>For urgent malfunctions and maintenance issues.</p>
      <p>In case of elevator malfunctions, central heating issues or other urgent matters:</p>
      <ul>
        <li><strong>Elevator malfunction:</strong> Call the number on the elevator directly</li>
        <li><strong>Heating issue (Tower):</strong> Contact the manager</li>
        <li><strong>Water damage/Leakage:</strong> In emergencies: 06-XXXXXXXX</li>
      </ul>
      <p class="note">In case of acute danger or emergencies, always call 112.</p>
    `,
    
    // Committee section
    committeeTitle: 'Bewonerscommissie',
    committeeTitleEn: 'Residents Committee',
    committeeHtml: `
      <p>De bewonerscommissie behartigt de belangen van alle bewoners en organiseert activiteiten.</p>
      <p>Leden van de bewonerscommissie:</p>
      <ul>
        <li>Gina ter Elst (voorzitter) - App. 237</li>
        <li>Jan Pietersen - App. 245</li>
        <li>Maria Jansen - App. 219</li>
      </ul>
      <p>Voor vragen of interesse om bij te dragen aan activiteiten, neem contact op via <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
    `,
    committeeHtmlEn: `
      <p>The residents committee represents the interests of all residents and organizes activities.</p>
      <p>Members of the residents committee:</p>
      <ul>
        <li>Gina ter Elst (chairperson) - App. 237</li>
        <li>Jan Pietersen - App. 245</li>
        <li>Maria Jansen - App. 219</li>
      </ul>
      <p>For questions or interest in contributing to activities, contact via <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
    `,
    
    // Facilities section
    facilitiesTitle: 'Openingstijden Gemeenschappelijke Ruimtes',
    facilitiesTitleEn: 'Opening Hours of Common Areas',
    facilitiesHtml: `
      <p>Informatie over de toegankelijkheid van gedeelde ruimtes in het gebouw.</p>
      <table class="opening-hours">
        <tbody>
          <tr>
            <td><strong>Fietsenstalling:</strong></td>
            <td>24/7 toegankelijk met sleutel</td>
          </tr>
          <tr>
            <td><strong>Recreatieruimte:</strong></td>
            <td>10:00 - 22:00 uur (reservering via beheerder)</td>
          </tr>
          <tr>
            <td><strong>Wasruimte:</strong></td>
            <td>08:00 - 21:00 uur</td>
          </tr>
        </tbody>
      </table>
    `,
    facilitiesHtmlEn: `
      <p>Information about the accessibility of shared spaces in the building.</p>
      <table class="opening-hours">
        <tbody>
          <tr>
            <td><strong>Bike storage:</strong></td>
            <td>24/7 accessible with key</td>
          </tr>
          <tr>
            <td><strong>Recreation area:</strong></td>
            <td>10:00 - 22:00 (reservation via manager)</td>
          </tr>
          <tr>
            <td><strong>Laundry room:</strong></td>
            <td>08:00 - 21:00</td>
          </tr>
        </tbody>
      </table>
    `
  });
  const [loading, setLoading] = useState(true);
  const [editSection, setEditSection] = useState(null);
  const isAuthenticated = !!localStorage.getItem('token');

  // Load page content
  useEffect(() => {
    const loadPageContent = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/page-content/contact`);
        const data = await response.json();
        
        console.log("Raw API response:", data);
        
        // Check if the data is what we expect
        if (data && typeof data === 'object') {
          // If data has all the section fields directly (like boardTitle), use it directly
          if (data.boardTitle) {
            console.log("Data has direct section fields");
            setPageContent(prev => ({
              ...prev, // Keep defaults
              ...data  // Override with loaded content
            }));
          } 
          // If data has a content field that contains the section fields
          else if (data.content && data.content.boardTitle) {
            console.log("Data has nested content field");
            setPageContent(prev => ({
              ...prev,        // Keep defaults
              ...data.content // Override with loaded content
            }));
          }
          // If we don't recognize the structure, log it
          else {
            console.log("Unrecognized data structure:", data);
            // Try to use it anyway
            setPageContent(prev => ({
              ...prev,
              ...(data.content || data)
            }));
          }
        }
      } catch (error) {
        console.error('Error loading page content:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPageContent();
  }, []);

  // Handle saving content
  const handleSaveContent = async () => {
    try {
      console.log("Saving contact content:", pageContent); // Debug
      
      // Create a properly structured content object for the API
// Create a properly structured content object for the API
const contentToSave = Object.fromEntries(
  Object.entries({
    title: pageContent.title,
    titleEn: pageContent.titleEn,
    boardTitle: pageContent.boardTitle,
    boardTitleEn: pageContent.boardTitleEn,
    boardHtml: pageContent.boardHtml,
    boardHtmlEn: pageContent.boardHtmlEn,
    managerTitle: pageContent.managerTitle,
    managerTitleEn: pageContent.managerTitleEn,
    managerHtml: pageContent.managerHtml,
    managerHtmlEn: pageContent.managerHtmlEn,
    maintenanceTitle: pageContent.maintenanceTitle,
    maintenanceTitleEn: pageContent.maintenanceTitleEn,
    maintenanceHtml: pageContent.maintenanceHtml,
    maintenanceHtmlEn: pageContent.maintenanceHtmlEn,
    committeeTitle: pageContent.committeeTitle,
    committeeTitleEn: pageContent.committeeTitleEn,
    committeeHtml: pageContent.committeeHtml,
    committeeHtmlEn: pageContent.committeeHtmlEn,
    facilitiesTitle: pageContent.facilitiesTitle,
    facilitiesTitleEn: pageContent.facilitiesTitleEn,
    facilitiesHtml: pageContent.facilitiesHtml,
    facilitiesHtmlEn: pageContent.facilitiesHtmlEn,
    widgetType: 'contact'
  }).filter(([_, value]) => value !== undefined && value !== null && value !== '')
);
      
      // Save to localStorage as immediate backup
      localStorage.setItem(`vve_contact_cache`, JSON.stringify(contentToSave));
      
      console.log("Sending to server:", contentToSave);
      
      // Make direct API call instead of using the service
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('No authentication token found');
        alert('Authentication error. Please log in again.');
        return false;
      }
      
      // Use fetch for more control over the request
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api/page-content/contact`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(contentToSave)
      });
      
      console.log("Response status:", response.status);
      
      // Handle non-JSON responses gracefully
      let responseData;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        responseData = await response.json();
        console.log("Response data:", responseData);
      } else {
        const text = await response.text();
        console.log("Response text:", text);
        responseData = { message: text };
      }
      
      if (response.ok) {
        alert('Content saved successfully!');
        setEditSection(null); // Close edit mode
        return true;
      } else {
        const errorMsg = responseData.error || responseData.message || 'Unknown error';
        alert('Error saving content to server: ' + errorMsg);
        return false;
      }
    } catch (error) {
      console.error('Error saving page content:', error);
      alert('Error saving content to server, but content is saved locally.');
      return false;
    }
  };

  // Get section content based on language
  const getSectionContent = (nlContent, enContent) => {
    return language === 'en' ? enContent : nlContent;
  };

  // Handle input change for specific section fields
  const handleInputChange = (field, value) => {
    setPageContent(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Edit section modal
  const renderEditModal = () => {
    if (!editSection) return null;
    
    // Determine which section to edit
    let titleField, titleFieldEn, contentField, contentFieldEn;
    let title = '';
    
    switch (editSection) {
      case 'board':
        titleField = 'boardTitle';
        titleFieldEn = 'boardTitleEn';
        contentField = 'boardHtml';
        contentFieldEn = 'boardHtmlEn';
        title = 'Edit Board Section';
        break;
      case 'manager':
        titleField = 'managerTitle';
        titleFieldEn = 'managerTitleEn';
        contentField = 'managerHtml';
        contentFieldEn = 'managerHtmlEn';
        title = 'Edit Manager Section';
        break;
      case 'maintenance':
        titleField = 'maintenanceTitle';
        titleFieldEn = 'maintenanceTitleEn';
        contentField = 'maintenanceHtml';
        contentFieldEn = 'maintenanceHtmlEn';
        title = 'Edit Maintenance Section';
        break;
      case 'committee':
        titleField = 'committeeTitle';
        titleFieldEn = 'committeeTitleEn';
        contentField = 'committeeHtml';
        contentFieldEn = 'committeeHtmlEn';
        title = 'Edit Committee Section';
        break;
      case 'facilities':
        titleField = 'facilitiesTitle';
        titleFieldEn = 'facilitiesTitleEn';
        contentField = 'facilitiesHtml';
        contentFieldEn = 'facilitiesHtmlEn';
        title = 'Edit Facilities Section';
        break;
      default:
        return null;
    }
    
    return (
      <div className="edit-modal-overlay">
        <div className="edit-modal">
          <div className="edit-modal-header">
            <h3>{title}</h3>
            <button className="close-modal-button" onClick={() => setEditSection(null)}>&times;</button>
          </div>
          
          <div className="edit-modal-content">
            <div className="edit-field">
              <label>Dutch Title:</label>
              <input
                type="text"
                value={pageContent[titleField] || ''}
                onChange={(e) => handleInputChange(titleField, e.target.value)}
                placeholder="Enter title in Dutch"
              />
            </div>
            
            <div className="edit-field">
              <label>English Title:</label>
              <input
                type="text"
                value={pageContent[titleFieldEn] || ''}
                onChange={(e) => handleInputChange(titleFieldEn, e.target.value)}
                placeholder="Enter title in English"
              />
            </div>
            
            <div className="edit-field">
              <label>Dutch Content (HTML):</label>
              <textarea
                value={pageContent[contentField] || ''}
                onChange={(e) => handleInputChange(contentField, e.target.value)}
                placeholder="Enter content in Dutch (HTML allowed)"
                rows={10}
              />
            </div>
            
            <div className="edit-field">
              <label>English Content (HTML):</label>
              <textarea
                value={pageContent[contentFieldEn] || ''}
                onChange={(e) => handleInputChange(contentFieldEn, e.target.value)}
                placeholder="Enter content in English (HTML allowed)"
                rows={10}
              />
            </div>
          </div>
          
          <div className="edit-modal-footer">
            <button className="cancel-button" onClick={() => setEditSection(null)}>Cancel</button>
            <button className="save-button" onClick={handleSaveContent}>Save Changes</button>
          </div>
        </div>
      </div>
    );
  };

  // Edit button for sections
  const EditButton = ({ section }) => {
    if (!isAuthenticated) return null;
    
    return (
      <button 
        className="section-edit-button" 
        onClick={() => setEditSection(section)}
      >
        <span className="icon">✏️</span>
      </button>
    );
  };

  if (loading) {
    return (
      <div className="page-with-sidebar">
        <ResidentSidebar language={language} setLanguage={setLanguage} />
        
        <div className="main-content contact-page-content" style={{ backgroundColor: '#f8fff4' }}>
          <div className="info-container contact-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>

          </div>
          
          <footer className="page-footer">
            <p>&copy; {new Date().getFullYear()} VVE Polderzicht • <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
          </footer>
        </div>
      </div>
    );
  }
  return (
    <div className="page-with-sidebar">
      <ResidentSidebar language={language} setLanguage={setLanguage} />
      
      <div className="main-content contact-page-content">
        <div className="info-container contact-page">
          <h1>
            {language === 'en' ? pageContent.titleEn : pageContent.title}
          </h1>
          
          <div className="contact-section">
            <div className="contact-card">
              <div className="card-header">
            
                <h2>{getSectionContent(pageContent.boardTitle, pageContent.boardTitleEn)}</h2>
                <EditButton section="board" />
              </div>
              <div 
                dangerouslySetInnerHTML={{ 
                  __html: getSectionContent(pageContent.boardHtml, pageContent.boardHtmlEn) 
                }} 
              />
            </div>
            
            <div className="contact-card">
              <div className="card-header">
         
                <h2>{getSectionContent(pageContent.managerTitle, pageContent.managerTitleEn)}</h2>
                <EditButton section="manager" />
              </div>
              <div 
                dangerouslySetInnerHTML={{ 
                  __html: getSectionContent(pageContent.managerHtml, pageContent.managerHtmlEn) 
                }} 
              />
            </div>
            
            <div className="contact-card">
              <div className="card-header">
          
                <h2>{getSectionContent(pageContent.maintenanceTitle, pageContent.maintenanceTitleEn)}</h2>
                <EditButton section="maintenance" />
              </div>
              <div 
                dangerouslySetInnerHTML={{ 
                  __html: getSectionContent(pageContent.maintenanceHtml, pageContent.maintenanceHtmlEn) 
                }} 
              />
            </div>
          </div>
          
          <div className="contact-section">
            <div className="contact-card wide-card">
              <div className="card-header">
          
                <h2>{getSectionContent(pageContent.committeeTitle, pageContent.committeeTitleEn)}</h2>
                <EditButton section="committee" />
              </div>
              <div 
                dangerouslySetInnerHTML={{ 
                  __html: getSectionContent(pageContent.committeeHtml, pageContent.committeeHtmlEn) 
                }} 
              />
            </div>
          </div>
          
          {/* <div className="contact-section">
            <div className="contact-card wide-card">
              <div className="card-header">
     
                <h2>{getSectionContent(pageContent.facilitiesTitle, pageContent.facilitiesTitleEn)}</h2>
                <EditButton section="facilities" />
              </div>
              <div 
                dangerouslySetInnerHTML={{ 
                  __html: getSectionContent(pageContent.facilitiesHtml, pageContent.facilitiesHtmlEn) 
                }} 
              />
            </div>
          </div> */}
        </div>
        
        <footer className="page-footer">
          <p>&copy; {new Date().getFullYear()} VVE Polderzicht • <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
        </footer>
        
        {/* Edit section modal */}
        {renderEditModal()}
      </div>
    </div>
  );
};

export default Contact;